import React from 'react';
export var getDictionary = function getDictionary(lang) {
  var language = lang || 'ru'; // eslint-disable-next-line global-require,@typescript-eslint/no-var-requires

  var texts = require('./loginwidget.json');

  return {
    t: function t(key) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          html = _ref.html,
          tag = _ref.tag;

      var SomeComponent = tag || 'span';
      var text = texts[key];

      if (!text) {
        return key;
      }

      if (language === 'ru') {
        var _value = text[language] || text.ru || text.en || key;

        return html ? /*#__PURE__*/React.createElement(SomeComponent, {
          dangerouslySetInnerHTML: {
            __html: _value
          }
        }) : _value;
      }

      var value = text[language] || text.en || text.ru || key;
      return html ? /*#__PURE__*/React.createElement(SomeComponent, {
        dangerouslySetInnerHTML: {
          __html: value
        }
      }) : value;
    }
  };
};